const timeViews = {
  hours: "soat",
  minutes: "daqiqa",
  seconds: "soniya",
  meridiem: "kunduzi/kechasi",
};

export const uzUZLatinPickers = {
  // Calendar navigation
  previousMonth: "Oldingi oy",
  nextMonth: "Keyingi oy",
  // View navigation
  openPreviousView: "Oldingi ko'rinishni ochish",
  openNextView: "Keyingi ko'rinishni ochish",
  calendarViewSwitchingButtonAriaLabel: (view) =>
    view === "year"
      ? "yil ko'rinishi ochilgan, kalendar ko'rinishiga o'tish"
      : "kalendar ko'rinishi ochilgan, yil ko'rinishiga o'tish",
  // DateRange labels
  start: "Boshlash",
  end: "Tugash",
  startDate: "Boshlash sanasi",
  startTime: "Boshlash vaqti",
  endDate: "Tugash sanasi",
  endTime: "Tugash vaqti",
  // Action bar
  cancelButtonLabel: "Bekor qilish",
  clearButtonLabel: "Tozalash",
  okButtonLabel: "Ok",
  todayButtonLabel: "Bugun",
  // Toolbar titles
  datePickerToolbarTitle: "Sanani tanlang",
  dateTimePickerToolbarTitle: "Sana va vaqtni tanlang",
  timePickerToolbarTitle: "Vaqtni tanlang",
  dateRangePickerToolbarTitle: "Davr tanlang",
  // Clock labels
  clockLabelText: (view, time, utils, formattedTime) =>
    `${timeViews[view]}ni tanlang. ${
      !formattedTime && (time === null || !utils.isValid(time))
        ? "Vaqt tanlanmagan"
        : `Vaqt tanlandi ${formattedTime ?? utils.format(time, "fullTime")}`
    }`,
  hoursClockNumberText: (hours) => `${hours} soat`,
  minutesClockNumberText: (minutes) => `${minutes} daqiqa`,
  secondsClockNumberText: (seconds) => `${seconds} soniya`,
  // Digital clock labels
  selectViewText: (view) => `${timeViews[view]}ni tanlang`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Hafta raqami",
  calendarWeekNumberHeaderText: "№",
  calendarWeekNumberAriaLabelText: (weekNumber) => `${weekNumber}-hafta`,
  calendarWeekNumberText: (weekNumber) => `${weekNumber}`,
  // Open picker labels
  openDatePickerDialogue: (value, utils, formattedDate) =>
    formattedDate || (value !== null && utils.isValid(value))
      ? `Sanani tanlang, tanlangan sana ${
          formattedDate ?? utils.format(value, "fullDate")
        }`
      : "Sanani tanlang",
  openTimePickerDialogue: (value, utils, formattedTime) =>
    formattedTime || (value !== null && utils.isValid(value))
      ? `Vaqtni tanlang, tanlangan vaqt ${
          formattedTime ?? utils.format(value, "fullTime")
        }`
      : "Vaqtni tanlang",
  fieldClearLabel: "Qiymatni o'chirish",
  // Table labels
  timeTableLabel: "vaqtni tanlang",
  dateTableLabel: "sanani tanlang",
  // Field section placeholders
  fieldYearPlaceholder: (params) => "Y".repeat(params.digitAmount),
  fieldMonthPlaceholder: (params) =>
    params.contentType === "letter" ? "OOOO" : "OO",
  fieldDayPlaceholder: () => "KUN",
  fieldWeekDayPlaceholder: (params) =>
    params.contentType === "letter" ? "HAFTA" : "HFT",
  fieldHoursPlaceholder: () => "SS",
  fieldMinutesPlaceholder: () => "DQ",
  fieldSecondsPlaceholder: () => "SN",
  fieldMeridiemPlaceholder: () => "K/T",
  // View names
  year: "Yil",
  month: "Oy",
  day: "Kun",
  weekDay: "Hafta kuni",
  hours: "Soat",
  minutes: "Daqiqa",
  seconds: "Soniya",
  meridiem: "Kunduzi/Kechasi",
  // Common
  empty: "Bo'sh",
};
